import * as _ from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatBotSender, randomResponse } from '../../pages/GemGPT/utils';

export interface IChatBotData {
  id: number;
  message: string;
  sender: ChatBotSender;
  timeStamp: string;
}

export interface IChatHistoryData {
  chatDateRange: string;
  chatHistory: {
    chatId: string;
    chatTitle: string;
    chatTimestamp: string;
  }[];
}

export interface IGemGPTSlice {
  componentStatus: { [name: string]: undefined | string | boolean | number };
  chatData: IChatBotData[];
  chatHistories: IChatHistoryData[];
  selectedChatId: string;
}

const createNewChat = (message: string, sender: ChatBotSender): IChatBotData => {
  const newChatData: IChatBotData = {
    id: Date.now(),
    message,
    sender,
    timeStamp: new Date().toLocaleTimeString(),
  };
  return newChatData;
};
function generateRandomNumber() {
  return (Math.floor(Math.random() * 100) + 1).toString();
}

const initialState: IGemGPTSlice = {
  componentStatus: {},
  chatData: [],
  chatHistories: [],
  selectedChatId: '',
};

const gemGPTSlice = createSlice({
  name: 'gemGPT',
  initialState,
  reducers: {
    setComponentStatus(
      state: IGemGPTSlice,
      action: PayloadAction<{ [key: string]: undefined | string | boolean | number }>,
    ) {
      state.componentStatus = { ...state.componentStatus, ...action.payload };
    },
    clearComponentStatus(state: IGemGPTSlice, action: PayloadAction<string[] | undefined>) {
      if (action.payload?.length) {
        state.componentStatus = _.omit(state.componentStatus, action.payload);
      } else {
        state.componentStatus = {};
      }
    },

    getGemGPTChatData(_state: IGemGPTSlice, _action: PayloadAction<string>) {},
    getGemGPTChatHistoriesData(_state: IGemGPTSlice) {},
    getGemGPTResponse(_state: IGemGPTSlice, _action: PayloadAction<string>) {},

    setSelectedChatId(state: IGemGPTSlice, action: PayloadAction<string>) {
      state.selectedChatId = action.payload;
    },
    setUserInput(state: IGemGPTSlice, action: PayloadAction<string>) {
      const newData = createNewChat(action.payload, ChatBotSender.USER);
      state.chatData = [...state.chatData, newData];
    },
    setBotResponse(state: IGemGPTSlice, _action: PayloadAction<IChatBotData>) {
      const newData = createNewChat(randomResponse(), ChatBotSender.BOT);
      state.chatData = [...state.chatData, newData];
    },
    setChatData(state: IGemGPTSlice, action: PayloadAction<IChatBotData[]>) {
      state.chatData = action.payload;
    },
    clearChatData(state: IGemGPTSlice) {
      state.chatData = [];
    },
    setChatHistoriesData(state: IGemGPTSlice, action: PayloadAction<IChatHistoryData[]>) {
      state.chatHistories = action.payload;
    },
    clearChatHistoriesData(state: IGemGPTSlice) {
      state.chatHistories = [];
    },
    removeChatFromList(state: IGemGPTSlice, action: PayloadAction<string>) {
      state.chatHistories = state.chatHistories.map((chatHistory) => ({
        ...chatHistory,
        chatHistory: chatHistory.chatHistory.filter((chat) => chat.chatId !== action.payload),
      }));
      state.selectedChatId = state.chatHistories[0].chatHistory[0].chatId;
    },
    addChatToList(state: IGemGPTSlice, action: PayloadAction<string>) {
      state.chatData = [];
      const randomNumber = generateRandomNumber();
      const newChatHistory = {
        chatId: randomNumber,
        chatTitle: action.payload,
        chatTimestamp: new Date().toString(),
      };
      if (state.chatHistories.length > 0) {
        state.chatHistories[0].chatHistory.push(newChatHistory);
      } else {
        state.chatHistories.push({
          chatDateRange: new Date().toLocaleDateString(),
          chatHistory: [newChatHistory],
        });
      }
      state.selectedChatId = randomNumber;
    },
    deleteChat(_state: IGemGPTSlice, _action: PayloadAction<string>) {},
    createNewChat(_state: IGemGPTSlice, _action: PayloadAction<string>) {},
  },
});

export const { actions: gemGPTActions, reducer: gemGPTReducer } = gemGPTSlice;
